// Port of api/fuel/app/classes/controller/api/monty/session/logout.php
import DB from 'offline/db'

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false

	if (!userId) {
		return Promise.reject({ error: 'User is already logged out.', offline: true })
	}

	DB.meta('sync_user_id', '')

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: {}
		}
	})
}
